import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { theme } from '../utilities/theme.js';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                ...theme
          },
        },
      },
});
